import React from "react";
import styles from "./ClearFix.module.css";

const ClearFix = () => {

    return (
        <span className={styles.clearFix}></span>
    )
}

export default ClearFix;